import styled, { css } from "styled-components";

interface HealthItemStyleProps {
  $modal?: boolean;
  $status?: "warn" | "good" | "danger";
}

export const HealthItem = styled.li`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 12px;
`;

export const HealthItemTit = styled.div`
  display: flex;
  width: 100%;
  min-height: 26px;
  color: ${(props) => props.theme.colors.black100};
  font-size: 1.6rem;
  font-weight: 700;
  align-items: center;
  justify-content: space-between;
`;

export const HealthItemContent = styled.ul`
  display: flex;
  padding: 24px;
  background: ${(props) => props.theme.colors.white100};
  border-radius: 10px;
  box-shadow: ${(props) => props.theme.shadows.box};
  flex-direction: column;
  gap: 26px;
`;

export const HealthItemData = styled.li`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
`;

export const DataLabel = styled.div<HealthItemStyleProps>`
  display: flex;
  height: 20px;
  align-items: center;
  gap: 4px;

  div {
    color: ${(props) => props.theme.colors.primary100};
    font-size: 1.4rem;
    line-height: 20px;
    white-space: nowrap;
  }

  ${(props) =>
    props.$modal === true &&
    css`
      div {
        color: ${props.theme.colors.primary100};
        font-weight: 800;
        border-bottom: 1px solid ${props.theme.colors.primary100};
      }
    `}
`;

export const DataValue = styled.div`
  display: flex;
  color: ${(props) => props.theme.colors.black80};
  font-size: 1.4rem;
  font-weight: 700;
  text-align: right;
  align-items: center;
  gap: 8px;
`;

export const DataStatus = styled.span<HealthItemStyleProps>`
  display: flex;
  width: 38px;
  height: 20px;
  color: ${(props) => props.theme.colors.white100};
  font-size: 1.1rem;
  border-radius: 3px;
  align-items: center;
  justify-content: center;

  ${(props) =>
    props.$status === "warn" &&
    css`
      background: ${props.theme.colors.yellow100};
    `}

  ${(props) =>
    props.$status === "good" &&
    css`
      background: ${props.theme.colors.green100};
    `}

  ${(props) =>
    props.$status === "danger" &&
    css`
      background: ${props.theme.colors.red100};
    `}
`;
